import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Fa from '../pages/fa';
import Class from '../pages/class';
import Growth from '../pages/growth';
import Expo from '../pages/expo';
import ExpoCustom from '../pages/expoCustom';
import Success from '../pages/success';
import SuccessFa from '../pages/successFa';
import CityPartner from '../pages/cityPartner';
import Conference from '../pages/conference';
import Media from '../pages/media';
const AppRouter = () => {
  return (
    <Router basename="/form">
      <div className="sign-wrapper">
        <Route path='/fa' exact component={Fa}></Route> {/* 投融资 */}
        <Route path='/class' exact component={Class}></Route> {/* A轮班 创业课堂 ... */}
        <Route path='/growth' exact component={Growth}></Route> {/* 创新成长学院 */}
        <Route path='/expo' component={Expo}></Route>  {/* 主题游学 */}
        <Route path='/expoCustom' component={ExpoCustom}></Route> {/* 游学定制 */}
        <Route path='/cityPartner' component={CityPartner}></Route> {/* 城市合伙人 */}
        <Route path='/conference' component={Conference}></Route> {/* 大会 */}
        <Route path="/media" component={Media}></Route> {/* 官网媒体报道 */}
        <Route path='/successFa' component={SuccessFa}></Route> {/* 报名成功页面 */}
        <Route path='/success' component={Success}></Route> {/* 报名成功页面 */}
      </div>
    </Router>
  )
}
export default AppRouter;
